export const actionKey = '@@config';
export const reduxKey = '@@config';
